/* eslint-disable no-restricted-imports */
import {
  Link,
  LinkProps,
  Navigate,
  NavigateOptions,
  NavigateProps,
  NavLink,
  NavLinkProps,
  To,
  useNavigate
} from 'react-router-dom';

import { AUTH_INFO_ID, PREFIX } from '@/constants/routes';
import { useAuthStore } from '@/store/auth';
import { PathParams, replacePathParams } from '@/utils/route';

type LinkParamsProps = {
  params?: PathParams;
} & LinkProps;

const usePrefixNavigate = () => {
  const navigate = useNavigate();
  const { authInfoId } = useAuthStore();

  return {
    goBack: () => navigate(-1),
    navigate: (route: To, options?: NavigateOptions, authInfoIdToVerify?: string) => {
      const { authInfoId } = useAuthStore.getState();
      if (typeof route === 'string' && route.match(PREFIX)) {
        navigate(replacePathParams(route, { [AUTH_INFO_ID]: authInfoIdToVerify || authInfoId }), options);
        return;
      }

      if (typeof route === 'object' && typeof route.pathname === 'string' && route.pathname.match(PREFIX)) {
        navigate({ ...route, pathname: replacePathParams(route.pathname, { [AUTH_INFO_ID]: authInfoId }) }, options);
        return;
      }

      navigate(route, options);
    },
    linkTo: (route: string, params?: PathParams) => {
      return replacePathParams(route, { [AUTH_INFO_ID]: authInfoId, ...params });
    },
    Navigate: (props: NavigateProps) => {
      if (typeof props.to === 'string') {
        return <Navigate {...props} to={replacePathParams(props.to, { [AUTH_INFO_ID]: authInfoId })} />;
      }
      const pathname = replacePathParams(props.to.pathname || '', { [AUTH_INFO_ID]: authInfoId });
      return <Navigate {...props} to={{ ...props.to, pathname }} />;
    },
    NavLink: (props: NavLinkProps) => {
      if (typeof props.to === 'string') {
        return <NavLink {...props} to={replacePathParams(props.to, { [AUTH_INFO_ID]: authInfoId })} />;
      }
      const pathname = replacePathParams(props.to.pathname || '', { [AUTH_INFO_ID]: authInfoId });
      return <NavLink {...props} to={{ ...props.to, pathname }} />;
    },
    Link: ({ params, ...rest }: LinkParamsProps) => {
      if (typeof rest.to === 'string') {
        return <Link {...rest} to={replacePathParams(rest.to, { [AUTH_INFO_ID]: authInfoId, ...params })} />;
      }
      const pathname = replacePathParams(rest.to.pathname || '', { [AUTH_INFO_ID]: authInfoId, ...params });
      return <Link {...rest} to={{ ...rest.to, pathname }} />;
    }
  };
};

export type UsePrefixNavigate = ReturnType<typeof usePrefixNavigate>;
export default usePrefixNavigate;
